<template>
    <div>
        <breadCrumb
                    :icon="'fa-clipboard-list-check'"
                    :category="$t(`sideNav.navSalonReport`)"
                    :subCategory="$t(`subMenu.salon_report_delivery`)"
                    :subSubCategory="''">
        </breadCrumb>
        <!-- <div class="row mt-3" v-if="!filterObj.voided">
            <div class="col-sm-6 col-xl-3" v-for="box in salesReportSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <div class="">
                        <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                            {{box.value}}
                            <small class="m-0 l-h-n fw-400 text-capitalize">{{box.text}}</small>
                        </h3>
                    </div>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div> -->
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4">
                    <deliveryFilter ref="deliveryFilter" @filterOrder="filterOrder"></deliveryFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content">
                            <deliveryList ref="deliveryList" @setExportData="setExportData" @onModalClose="onModalClose"></deliveryList>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DeliveryFilter from './Delivery_Filter'
import DeliveryList from './Delivery_List'
import _ from 'lodash';
import moment from 'moment'
import BreadCrumb from './../../Bread_Crumb'
import { handleSessionExpired, setSummaryBoxLabel } from './../../../../assets/js/dashboard/dashboard'
import box, { calculateSalesReportTotal } from './../../../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: 'reportDelivery',
    components: {
        DeliveryFilter, DeliveryList, BreadCrumb
    },
    data() {
        return {
            salesReportSummaryBox: [],
            outlet: [],
            paymentType: [], filterObj: {},
        }
    },
    watch: {
        "$i18n.locale"(val) {
            this.setSummaryBoxLabel()
        }
    },
    methods: {
        setSummaryBoxLabel() {
            var _box = box.salesReportSummaryBox
            this.salesReportSummaryBox = setSummaryBoxLabel(this, 'sales', _box.slice())
        },
        setExportData(item) {
            this.exportObj = item
            this.$refs.deliveryFilter.setExportData(item)
        },

        async getCityList() {
            let $vm = this;
            const url = $vm.$api.INFO + $vm.$api.CITY;

            var city = [];
            await $vm
                .$axios({
                    method: "get",
                    url: url,
                    baseURL: $vm.$axios.defaults.baseURL,
                    headers: { token: $vm.$session.get("token") },
                })
                .then(function (response) {
                    city = response.data.result;
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if (error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                });

            this.$refs.deliveryList.setCity(city)
        },

        async filterOrder(filterObj) {
            this.filterObj = filterObj
            this.$refs.deliveryList.isSpinnerShow = true
            var completeds = await this.getCompletedItems(filterObj)
            var sales = await this.getSalesItems(filterObj)

            let completedMap = {}
            for (let completed of completeds) {
                if (!completed['item'] || completed['item']['type'] !== 'product') {
                    continue
                }
                completedMap[completed.salesID] = completedMap[completed.salesID] || {}

                let itemID = completed['item']['itemID']
                completedMap[completed.salesID][itemID] = completedMap[completed.salesID][itemID] || completed['item']

                completed['item']['quantity'] = completed['item']['quantity'] || 0
                completed['item']['quantity']++
            }

            let memberMap = {}
            for (let member of sales['members']) {
                memberMap[member.memberID] = member
            }

            let final = []
            for (let sale of sales['sales']) {
                if (sales['createDate'] < moment(filterObj.date.startDate).unix() || sales['createDate'] > moment(filterObj.date.startDate).unix()) {
                    continue
                }

                let completed = completedMap[sale['saleID']]
                if (!completed) {
                    continue
                }

                let items = []
                for (let itemID in completed) {
                    items.push(completed[itemID])
                }

                if (sale['deliveredDate']) {
                    if (filterObj['deliveryState'] !== 'all' && filterObj['deliveryState'] !== 'delivered') {
                        continue
                    }

                    sale['status'] = 'Delivered'
                    sale['date'] = sale['deliveredDate']
                } else if (sale['packageDate']) {
                    if (filterObj['deliveryState'] !== 'all' && filterObj['deliveryState'] !== 'packaged') {
                        continue
                    }

                    sale['status'] = 'Packaged'
                    sale['date'] = sale['packageDate']
                } else if (sale['deliveryDate']) {
                    if (filterObj['deliveryState'] !== 'all' && filterObj['deliveryState'] !== 'delivery') {
                        continue
                    }

                    sale['status'] = 'Delivery'
                    sale['date'] = sale['deliveryDate'] || ''
                } else {
                    if (filterObj['deliveryState'] !== 'all' && filterObj['deliveryState'] !== 'new') {
                        continue
                    }

                    sale['status'] = 'New'
                }

                let member = memberMap[sale['memberID']] || {}

                final.push(Object.assign(sale, {
                    memberName: member['name'],
                    memberMobile: member['mobile'],
                    items: items,
                }))
            }

            this.$refs.deliveryList.setOrderItems(final, filterObj)
            // if(!filterObj.voided){
            //     this.setTotalData(completed)
            // }
        },
        async getCompletedItems(filterObj) {
            var dateFilter = "?startDate=" + moment(filterObj.date.startDate).format('DD/MM/YYYY') + "&endDate=" + moment(filterObj.date.endDate).format('DD/MM/YYYY')
            var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            var voidFilter = "&active=" + (filterObj.voided ? "0" : "1")
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search

            let QUERY_STRING = dateFilter + outletFilter + searchFilter + voidFilter

            const url = this.$api.REPORT_COMPLETED + QUERY_STRING;
            var result = [];
            await this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: this.$util.getSessionToken() }
            })
                .then(function (response) {
                    result = response.data.result;
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == "Invalid Token") {
                        handleSessionExpired();
                    }
                })
            return result;
        },
        async getSalesItems(filterObj) {
            var dateFilter = "?startDate=" + moment(filterObj.date.startDate).unix() + "&endDate=" + moment(filterObj.date.endDate).unix()
            var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search
            var voidFilter = "&active=" + (filterObj.voided ? "0" : "1")

            let QUERY_STRING = dateFilter + outletFilter + searchFilter + voidFilter

            const url = this.$api.BUSINESS_SALES + QUERY_STRING;
            var result = [];
            await this.$axios({
                method: 'get',
                url: url,
                baseURL: this.$api.API_ENDPOINT_ORDER,
                headers: { token: this.$util.getSessionToken() }
            })
                .then(function (response) {
                    result = response.data;
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == "Invalid Token") {
                        handleSessionExpired();
                    }
                })
            return result
        },

        setTotalData(item) {
            var data = calculateSalesReportTotal(item)

            for (var i = 0; i < this.salesReportSummaryBox.length; i++) {
                switch (this.salesReportSummaryBox[i].id) {
                    case "sales":
                        this.salesReportSummaryBox[i].value = parseFloat(data.totalSales).toFixed(2);
                        break
                    case "credit_redeem":
                        this.salesReportSummaryBox[i].value = parseFloat(data.totalCredits).toFixed(2);
                        break
                    case "package_redeem":
                        this.salesReportSummaryBox[i].value = parseFloat(data.totalPackage).toFixed(2);
                        break
                    case "total":
                        this.salesReportSummaryBox[i].value = parseFloat(data.subTotal).toFixed(2);
                        break
                }
            }
        },

        onModalClose(){
            this.filterOrder(this.filterObj);
        },
    },
    async mounted() {
        let $vm = this
        $vm.setSummaryBoxLabel()
        $vm.getCityList()
    },
}
</script>